import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AlertController, AlertOptions } from 'ionic-angular';

import { Authentication } from '../../providers/authentication';
import { UsersPage } from '../users/users';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  private credentials = { username: '', password: '' };
  private loginSuccessPage = UsersPage;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private authService: Authentication,
  ) { }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');

    let token = this.authService.getToken();
    if (token) {
      this.authService.loginWithToken({ token: token }).subscribe(
        result => { if (result) { this.loginSuccess(); } },
        err => {
          console.error(err);
          if (err.status == 400 && err.statusText == 'Bad Request') {
            if (err.json()['non_field_errors'][0] == 'Signature has expired.') {
              console.info('Removing expired token');
              this.authService.removeToken();
            }
          }
        }
      );
    }

    // this.authService.isAuthenticated()
    //   .subscribe(
    //   result => { if (result) { this.loginSuccess(); } },
    //   err => {
    //     console.error(err);
    //     if (err.status == 400 && err.statusText == 'Bad Request') {
    //       if (err.json()['non_field_errors'][0] == 'Signature has expired.') {
    //         console.info('Removing expired token');
    //         this.authService.removeToken();
    //       }
    //     }
    //   }
    // );
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter LoginPage');
    // let token = this.authService.getToken();
    // if (token) {
    //   this.authService.loginWithToken({ token: token }).subscribe();
    // }
  }

  submit() {
    this.authService.login(this.credentials)
      .subscribe(result => {
        if (result) { this.resetCredentials(); this.loginSuccess(); }
        else { this.loginFailed('Login failed', 'Please try again.'); }
      }
      );
  }

  loginSuccess() {
    this.showLoginSuccessAlert();
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.navCtrl.setRoot(this.loginSuccessPage)
      .catch(() => {
        console.error('UNAUTH');
      });
  }

  loginFailed(reason, detail) {
    this.showLoginFailedAlert({
      title: reason,
      subTitle: detail,
    });
  }

  showLoginSuccessAlert(options: AlertOptions = {}) {
    this.showAlert(Object.assign({}, {
      title: 'Hooray!',
      subTitle: 'You are logged in!',
      buttons: ['OK']
    }, options));
  }

  showLoginFailedAlert(options: AlertOptions = {}) {
    this.showAlert(Object.assign({}, {
      title: 'Uh oh!',
      subTitle: 'Login failed!',
      buttons: ['OK']
    }, options));
  }

  showAlert(options: AlertOptions) {
    let alert = this.alertCtrl.create(Object.assign({}, options));
    alert.present();
  }

  resetCredentials() {
    this.credentials = { username: '', password: '' };
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts